import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const GenerateClassOfferingsMutation = graphql.persisted(
  "GenerateClassOfferings",
  graphql(`
    mutation GenerateClassOfferings($input: GenerateClassOfferingsInput!) {
      generateClassOfferings(input: $input) {
        classOfferings {
          id
          section
          displayName
        }
        createdClassOfferings {
          id
          section
          displayName
        }
        createdCount
        unchangedCount
        preservedCount
        message
        userErrors {
          message
          path
          code
        }
      }
    }
  `)
);

export { GenerateClassOfferingsMutation };

export function useGenerateClassOfferings() {
  return useMutation(GenerateClassOfferingsMutation);
}
